// components/History.jsx
import React, { useState, useEffect } from 'react';
import './History.css';

const History = () => {
  const [sectionTitle, setSectionTitle] = useState("");
  const [sectionSubtitle, setSectionSubtitle] = useState("");
  const [historyEvents, setHistoryEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchHistoryData();
  }, []);

  const fetchHistoryData = async () => {
    try {
      setLoading(true);
      // const response = await fetch('http://localhost/ivtcms/api/rubriques/by-url/Notre-Histoire');
      const response = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Notre-Histoire`,)

      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.success && data.data) {
        const rubriqueData = data.data;
        
        // Extraire le titre et le sous-titre du HTML
        let title = "";
        let subtitle = "";
        
        if (rubriqueData.descriptif) {
          try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(rubriqueData.descriptif, 'text/html');
            
            // Extraire le titre
            const titleElement = doc.querySelector('.section-title');
            if (titleElement) {
              title = titleElement.textContent.trim();
            }
            
            // Extraire le sous-titre
            const subtitleElement = doc.querySelector('.section-subtitle');
            if (subtitleElement) {
              subtitle = subtitleElement.textContent.trim();
            }
          } catch (parseError) {
            console.warn('Erreur lors du parsing HTML:', parseError);
          }
        }
        
        // Si pas de titre extrait, utiliser le titre de la rubrique
        setSectionTitle(title || rubriqueData.titre || "");
        setSectionSubtitle(subtitle || "Un parcours d'innovation et de croissance continue depuis nos débuts");
        
        // Récupérer les articles (événements historiques)
        if (rubriqueData.articles && rubriqueData.articles.length > 0) {
          const formattedEvents = rubriqueData.articles.map((article) => ({
            year: article.soustitre || "",
            title: article.titre || "",
            description: article.descriptif || article.descriptif_short || ""
          }));
          
          setHistoryEvents(formattedEvents);
        } else {
          setHistoryEvents([]);
        }
      } else {
        throw new Error('Données de rubrique non disponibles');
      }
      
    } catch (err) {
      console.error('Erreur lors de la récupération des données:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="history-section" id="history">
        <div className="contenir">
          {/* Placeholder pour l'en-tête */}
          <div className="section-header">
            <div className="loading-placeholder" style={{ 
              height: '40px', 
              width: '200px',
              marginBottom: '1rem',
              background: '#f0f0f0',
              borderRadius: '4px'
            }}></div>
            
            <div className="section-divider"></div>
            
            <div className="loading-placeholder" style={{ 
              height: '20px', 
              width: '80%',
              margin: '0 auto',
              background: '#f0f0f0',
              borderRadius: '4px'
            }}></div>
          </div>

          {/* Placeholder pour la timeline */}
          <div className="history-timeline">
            {[1, 2, 3].map(i => (
              <div key={i} className="history-item">
                <div className="history-year">
                  <div className="loading-placeholder" style={{ 
                    width: '80px', 
                    height: '80px',
                    borderRadius: '50%',
                    background: '#f0f0f0'
                  }}></div>
                </div>
                
                <div className="year-separator">
                  <div className="separator-dot"></div>
                  <div className="vertical-line"></div>
                </div>
                
                <div className="history-content">
                  <div className="history-card">
                    <div className="loading-placeholder" style={{ 
                      height: '30px', 
                      width: '70%',
                      marginBottom: '1rem',
                      background: '#f0f0f0',
                      borderRadius: '4px'
                    }}></div>
                    
                    <div className="loading-placeholder" style={{ 
                      height: '60px', 
                      background: '#f0f0f0',
                      borderRadius: '4px'
                    }}></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="history-section" id="history">
        <div className="contenir">
          <div className="section-header">
            <h2 className="section-title">Notre Histoire</h2>
            <div className="section-divider"></div>
            <p className="section-subtitle" style={{color: '#ff6b6b'}}>
              Erreur de chargement : {error}
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="history-section" id="history">
      <div className="contenir">
        {/* En-tête de la section */}
        <div className="section-header">
          <h2 className="section-title">{sectionTitle}</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">
            {sectionSubtitle}
          </p>
        </div>

        {/* Timeline avec alternance */}
        {historyEvents.length > 0 && (
          <div className="history-timeline">
            {historyEvents.map((event, index) => (
              <div 
                key={index} 
                className={`history-item ${index % 2 === 1 ? 'history-item-reverse' : ''}`}
              >
                {/* Année - à gauche pour les pairs, à droite pour les impairs */}
                <div className={`history-year ${index % 2 === 1 ? 'history-year-right' : ''}`}>
                  <span className="year-number">{event.year}</span>
                </div>
                
                {/* Séparateur vertical avec point */}
                <div className="year-separator">
                  <div className="separator-dot"></div>
                  <div className="vertical-line"></div>
                </div>
                
                {/* Carte - à droite pour les pairs, à gauche pour les impairs */}
                <div className={`history-content ${index % 2 === 1 ? 'history-content-left' : ''}`}>
                  <div className="history-card">
                    <h3 className="card-title">{event.title}</h3>
                    <p className="card-description">{event.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default History;